import { __decorate, __metadata } from "tslib";
import { Expose } from 'class-transformer';
import { IsNumber, IsString } from 'class-validator';
import { WebMerchantExposeGroup } from '../interface';
export class ReadTextVariantDto {
    constructor(data) {
        Object.assign(this, data);
    }
}
__decorate([
    IsNumber(undefined, { always: true }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    __metadata("design:type", Number)
], ReadTextVariantDto.prototype, "fontSize", void 0);
__decorate([
    IsString({ always: true }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    __metadata("design:type", Object)
], ReadTextVariantDto.prototype, "color", void 0);
__decorate([
    IsString({ always: true }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    __metadata("design:type", String)
], ReadTextVariantDto.prototype, "fontFamily", void 0);
__decorate([
    IsString({ always: true }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    __metadata("design:type", String)
], ReadTextVariantDto.prototype, "fontWeight", void 0);
//# sourceMappingURL=ReadTextVariantDto.js.map